import { FC, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'

import { Nav, NO_SYNDEO_DASHBOARD } from '../../../containers/_sidenav'
import { SYNDEO_EXTERNAL_LINKS } from '../../../utils/constants'
import { ROUTES } from '../../../utils/constants/enum'
import { conditionalClasses } from '../../../utils/helper-functions'

import './sidebar.scss'

interface SidebarTypes {
    sidebarNav?: Array<Nav>
}

const SideBar: FC<SidebarTypes> = ({ sidebarNav }) => {
    const location = useLocation()
    const { t } = useTranslation()

    const pathName = location.pathname

    const showDashboard = useMemo(() => {
        return !NO_SYNDEO_DASHBOARD.includes(location.pathname || '')
    }, [location.pathname])

    return (
        <div
            className={conditionalClasses(
                showDashboard,
                'show',
                '',
                'nav-links hide-mobile hide-tablet'
            )}
        >
            {sidebarNav?.map(({ label, link }) => (
                <div
                    //temporary solution to highlight client rewards in sidebar when rewards history page is open, needs to be changed
                    className={`menu-item-wrapper ${
                        (pathName.includes(link?.toString() || '') &&
                            link !== ROUTES.DASHBOARD) ||
                        (link === ROUTES.DASHBOARD &&
                            pathName === ROUTES.DASHBOARD)
                            ? 'active'
                            : ''
                    }`}
                    key={label}
                >
                    {link && SYNDEO_EXTERNAL_LINKS.includes(link) && (
                        <a href={link} target="_blank" rel="noreferrer">
                            {t(label).toUpperCase()}
                        </a>
                    )}

                    {link && !SYNDEO_EXTERNAL_LINKS.includes(link) && (
                        <Link className="menu-item" to={link}>
                            {t(label).toUpperCase()}
                        </Link>
                    )}
                </div>
            ))}
        </div>
    )
}

export default SideBar
